// Copyright (c) 2016 Deere & Company

import busyCounter from '../../../shared/reducers/busy-counter';
import {combineReducers} from 'redux';
import facets from './facets';
import hasSearchResults from '../../shared/reducers/has-search-results';
import isMoreSummaryVisible from './show-more-groups-visibility';
import isVisible from './labor-additive-summary-modal-visibility';
import laborAdditiveSummaries from './labor-additive-summaries';
import laborAdditiveSummary from './labor-additive-summary';
import pipProducts from './pip-products';
import pipProductsFiltered from './pip-products-filtered';
import searchByDropDown from '../../shared/reducers/search-dropdown';
import searchFilters from './search-filters';
import searchQueryString from '../../shared/reducers/search-query-string';

export const getCombinedReducers = () => combineReducers({
    busyCounter,
    facets,
    hasSearchResults,
    isMoreSummaryVisible,
    isVisible,
    laborAdditiveSummaries,
    laborAdditiveSummary,
    pipProducts,
    pipProductsFiltered,
    searchByDropDown,
    searchFilters,
    searchQueryString
});



// WEBPACK FOOTER //
// ./src/pip/labor-additive/reducers/index.js